import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1328f266"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-error text-sm"
}

import { ref, computed } from "vue"
  import { VueTelInput } from "vue3-tel-input"
  import WbInput from "./InputTemplate.vue"
  import "vue3-tel-input/dist/vue3-tel-input.css"

  interface Props {
    modelValue: string
    name: string
    placeholder?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneTemplate',
  props: {
    modelValue: null,
    name: null,
    placeholder: null
  },
  emits: ["update:modelValue", "validity"],
  setup(__props: any, { emit }) {

const props = __props as {
    modelValue: string
    name: string
    placeholder?: string
  }

  
  
  const phone = computed({
    get: () => props.modelValue,
    set: (val) => emit("update:modelValue", val),
  })
  const isValid = ref(true)

  /**
   * set value of input
   * @param val - string value of input
   * @param phoneObject - object data of retrun
   * @param input - event of input
   */
  const onInput = (val: string, phoneObject: any, input: InputEvent) => {
    if (phoneObject?.formatted) phone.value = phoneObject.formatted
    if (phoneObject?.valid != null && val.length > 0) {
      isValid.value = phoneObject?.valid
      emit("validity", phoneObject?.valid)
    } else if (val.length == 0) {
      phone.value = ""
      isValid.value = true
      emit("validity", true)
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VueTelInput), {
      value: _unref(phone),
      "auto-format": "",
      "default-country": "ph",
      "dropdown-options": {
        showSearchBox: true,
        showDialCode: true,
        showFlags: true,
        showDialCodeInSelection: true,
      },
      mode: "international",
      class: "h-[45px] w-full rounded-xl pl-5 outline-none transition ease-out duration-200 bg-light-gray-100",
      "input-options": { placeholder: __props.placeholder || 'Enter your phone number' },
      onInput: onInput
    }, null, 8, ["value", "input-options"]),
    _createVNode(WbInput, {
      modelValue: _unref(phone),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(phone) ? (phone).value = $event : null)),
      name: props.name,
      "input-class": "hidden"
    }, null, 8, ["modelValue", "name"]),
    (!isValid.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Invalid phone number"))
      : _createCommentVNode("", true)
  ]))
}
}

})